<template>
  <LoadingBlock :loading="storeLoading">
    <form @submit.prevent="submitForm">
      <slot name="top"></slot>
      <h5>Основные настройки</h5>
      <div class="col mb-4">
        <label class="form-label">Название магазина</label>
        <input type="text" name="name" class="form-control" placeholder="" required v-model="item_data.name">
      </div>
      <input type="hidden" name="company" v-model="item_data.company">
      <input type="hidden" name="id" v-model="item_data.id" v-if="item_data.id">
      
      <slot name="connection" :item_data="item_data"></slot>

      <div class="col mb-4">
        <label class="form-label">Фиксированная комиссия (например, обработка отправления в ПВЗ), руб.</label>
        <input type="text" name="settings[fixed_commission]" class="form-control" placeholder=""
               v-model="item_data.settings.fixed_commission">
      </div>
      <div class="col mb-4">
        <label class="form-label">Дополнительная комиссия (реклама, досрочная выплата и т.п.), %</label>
        <input type="text" name="settings[percent_commission]" class="form-control" placeholder=""
               v-model="item_data.settings.percent_commission">
      </div>

      <slot name="settings" :item_data="item_data"></slot>

      <div v-if="item_data && item_data.schedule">
        <h5 class="mt-4 border-top pt-3">Планировщик задач</h5>
        <div class="col mb-4">
          <label class="form-label">Автоматическая загрузка товаров</label>
          <small class="form-text text-muted d-block mb-2">Выберите часы для запуска. Чтобы отключить, не выбирайте ничего. (не более 2, разница более 2 часов)</small>
          <MultiSelect v-model="item_data.schedule.import_products" :options="hoursOptions" optionLabel="label" optionValue="value" placeholder="Выберите часы" display="chip" class="w-100" :selection-limit="2" @change="validateHourDifference('import_products')"/>
        </div>

        <div class="col mb-4">
          <label class="form-label">Автоматическая загрузка цен</label>
          <small class="form-text text-muted d-block mb-2">Выберите часы для запуска. (не более 2, разница более 2 часов)</small>
          <MultiSelect v-model="item_data.schedule.get_offers" :options="hoursOptions" optionLabel="label" optionValue="value" placeholder="Выберите часы" display="chip" class="w-100" :selection-limit="2" @change="validateHourDifference('get_offers')"/>
        </div> 

        <div class="col mb-4">
          <label class="form-label">Автоматическая загрузка заказов</label>
          <small class="form-text text-muted d-block mb-2">Выберите интервал для запуска.</small>
          <Select v-model="item_data.schedule.get_orders" :options="orderIntervalOptions" optionLabel="label" optionValue="value" placeholder="Выберите интервал" class="w-100" />
        </div>
      </div>

      <div class="col mb-4">
        <button type="submit" class="btn btn-primary me-4 waves-effect waves-light">Сохранить</button>
      </div>
    </form>
  </LoadingBlock>
</template>
<script>
import {user} from "@/data/user";
import {Message, Messages} from "@/data/messages";
import LoadingBlock from "@/components/page/LoadingBlock.vue";
import MultiSelect from 'primevue/multiselect';
import Select from 'primevue/select';

export default {
  name: "MarketplaceForm",
  components: {LoadingBlock, MultiSelect, Select},
  data() {
    return {
      item_data: null,
      storeLoading: true
    }
  },
  props: ['item', 'defaultItemData', 'newStoreFn', 'editStoreFn'],
  computed: {
    hoursOptions() {
      return Array.from({length: 24}, (_, i) => ({
        label: `${i.toString().padStart(2, '0')}:00`,
        value: i
      }));
    },
    orderIntervalOptions() {
      return [
        { label: 'Не запускать', value: null },
        { label: 'Каждые 15 минут', value: '15' },
        { label: 'Каждые 30 минут', value: '30' },
        { label: 'Каждые 60 минут', value: '60' },
        { label: 'Каждые 3 часа', value: '180' },
        { label: 'Каждые 6 часов', value: '360' },
        { label: 'Каждые 12 часов', value: '720' }
      ];
    }
  },
  created() {
    this.item_data = this.item ? JSON.parse(JSON.stringify(this.item)) : JSON.parse(JSON.stringify(this.defaultItemData));
    if (this.item_data && !this.item_data.schedule) {
      this.item_data.schedule = {
        import_products: null,
        get_offers: null,
        get_orders: null,
      }
    }
  },
  mounted() {
    this.storeLoading = false
  },
  methods: {
    validateHourDifference(field) {
      this.$nextTick(() => {
        const values = this.item_data.schedule[field];
        if (values && values.length === 2) {
          const sorted = [...values].sort((a, b) => a - b);
          const h1 = sorted[0];
          const h2 = sorted[1];

          const diff = h2 - h1;
          const shortestDiff = Math.min(diff, 24 - diff);

          if (shortestDiff <= 2) {
            const message = new Message();
            message.type = 'failure';
            message.text = 'Разница между выбранными часами должна быть более 2 часов.';
            message.autoremove = 5;
            Messages.list.push(message);

            this.item_data.schedule[field] = [h1];
          }
        }
      });
    },
    async submitForm() {
      this.storeLoading = true
      const message = new Message()
      try {
        let result
        const text = !this.item_data.id ? 'Магазин успешно создан' : 'Настройки магазина изменены'
        if (!this.item_data.id) {
          this.item_data.company = await user.getActiveCompany()
          result = await this.newStoreFn(this.item_data)
        } else {
          result = await this.editStoreFn(this.item_data)
        }
        if (result.status === 200 || result.status === 201) {
          message.type = 'success'
          message.autoremove = 10
          message.text = text
          this.$emit('storeSuccess')
        } else {
          message.text = result.data?.message || 'Ошибка на стороне сервера, попробуйте позже или обратитесь в поддержку.'
          message.type = 'failure'
        }
      } catch (error) {
        message.type = 'failure'
        message.text = error.response?.data?.message || 'Ошибка на стороне сервера, попробуйте позже или обратитесь в поддержку.'
      }
      Messages.list.push(message)
      this.storeLoading = false
    }
  }
}
</script> 